<template>
  <div 
    class="search-bing-container" 
    @click="handleClick"
  >
    <!-- 高级艺术搜索符号 🔍︎ -->
    <img style="width: 36px; height: 36px;" src="@/assets/icon/icon-search.png" />
  </div>
</template>

<script>
export default {
  name: 'SearchBingBtu',
  methods: {
    handleClick() {
      this.$emit('upTypeRow', 'search-bing');
    }
  }
};
</script>

<style scoped>
/* 全局统一艺术毛玻璃按钮 —— 和 Tips、音乐完全一样 */
.search-bing-container {
  position: fixed;
  right: 6px;
  bottom: 95px;
  z-index: 9999;
  width: 50px;
  height: 50px;

  /* 全局统一样式 */
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  border: none;
  border-radius: 100%;

  /* 布局 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

/* 全局统一 hover 效果 */
.search-bing-container:hover {
  transform: scale(1.15);
  box-shadow: 0 0 12px rgba(255, 180, 180, 0.3);
}

/* 搜索图标样式 */
.search-icon {
  font-size: 36px;
  color: #fff;
  transition: transform 0.2s ease;
}
.search-bing-container:hover .search-icon {
  transform: rotate(15deg);
}
</style>